export enum ChartType {
  BAR = 'BAR',
  LINE = 'LINE',
  PIE = 'PIE',
  BAR_HORIZONTAL = 'BAR-HORIZONTAL'
}
